module.exports = __webpack_public_path__ + "img/banner.d5924286.png";